<template>
  <div :class="['quiz_main quiz_main--new_design', 'quiz_main_' + this.patientName + '_' + this.id, {
       'quiz_main--answered' : questionData.answered}]" :id="`quiz_${id}`">
    <div :class="['quiz_wrap', 'question_num--' + this.id, 'question_num--' + this.patientName + '-' + this.id ]">

      <div class="quiz_content">

        <h4 class="quiz_content_subtitle" v-html="questionData.subtitle"></h4>

        <ul :class="['question_progress', 'question_progress--' + this.id ]">
          <li class="question_progress_bullet"></li>
          <li class="question_progress_bullet"></li>
          <li class="question_progress_bullet"></li>
          <li class="question_progress_bullet"></li>
          <li class="question_progress_bullet"></li>
        </ul>

        <div class="quiz-title_container">
          <h3 class="quiz_content_title" v-html="questionData.title"></h3>
        </div>

        <div class="quiz_questions_block">
          <p v-if="!questionData.multi" class="quiz_helper">Select one</p>
          <p v-else class="quiz_helper">SELECT ALL THAT APPLY</p>
          <transition name="infoIn">
            <!--          -->
            <ol v-if="this.isQuizWithStats"
                :class="['quiz_questions_list', 'quiz_questions_list-percents', 'quiz_questions_list--' + this.id]">
              <li class="quiz_questions_list_item" v-for="(button, index) in questionData.buttons"
                  :key="button.order" @click.prevent="answerQuestion(button.order, button)"
                  :class="{
                'pull-answered' : questionData.answered === true,

                skipped: questionData.lastAnswer === 'skip',

                chosen: questionData.multi && multiResultState[button.order - 1] && !questionData.answered,

								chosenCorrect: typeof questionData.lastAnswer == 'object'
                ? questionData.lastAnswer[button.order-1] === true && questionData.answered === true && button.value === questionData.correctAnswer[button.order-1]
                : questionData.lastAnswer === button.value && questionData.answered === true && button.value === questionData.correctAnswer,

								chosenFalse: typeof questionData.lastAnswer == 'object'
                ? questionData.lastAnswer[button.order-1] === true && questionData.answered === true && button.value !== questionData.correctAnswer[button.order-1]
                : (questionData.lastAnswer === button.value) && questionData.answered === true && button.value !== questionData.correctAnswer && questionData.correctAnswer !== null,

								falseCorrect: typeof questionData.lastAnswer == 'object'
                ? !questionData.lastAnswer[button.order-1] && questionData.answered === true && button.value === questionData.correctAnswer[button.order-1]
                : questionData.lastAnswer !== button.value && questionData.answered === true && button.value === questionData.correctAnswer,

								noneCorrect: typeof questionData.lastAnswer == 'object'
                ? (questionData.lastAnswer[button.order-1] === button.value) && questionData.answered === true && questionData.correctAnswer[button.order-1] === undefined
                : (questionData.lastAnswer === button.value) && questionData.answered === true && questionData.correctAnswer === null,

								passive: resultState !== button.order && questionData.lastAnswer !== 'skip'
                }">
                <div class="left-box">
                  <span :class="['question_list_letter', 'answer-number-' + button.order]" v-html="button.letter"></span>
                </div>

                <div class="percent-wrapp">
                  <div class="percent-base"></div>
                  <div class="percent-color" :style="{ width: `${Math.round((poll_info[patientName][returnStatQuizID][button.letter] / poll_info[patientName][returnStatQuizID]['sum']) * 100)}%`}"></div>
                </div>

                <div class="percent_number">
                  <p class="percent_number-text">{{
                      index < Object.keys(questionData.buttons).length - 1 ? // check is last button
                      `${Math.round((poll_info[patientName][returnStatQuizID][button.letter] / poll_info[patientName][returnStatQuizID]['sum']) * 100)}%` :
                      `${lastButtonPercent}%`
                    }}</p>
                </div>

                <p :class="['quiz_questions_list_text', 'question_list_text', {'pull-text--answered' : questionData.answered === true}]" v-html="button.text"></p>
              </li>
            </ol>
            <!--            -->
            <ol v-else :class="['quiz_questions_list', 'quiz_questions_list--' + this.id]">
              <li class="quiz_questions_list_item" v-for="button in questionData.buttons"
                  :key="button.order" @click.prevent="answerQuestion(button.order, button)"
                  :class="{

                skipped: questionData.lastAnswer === 'skip',

                chosen: questionData.multi && multiResultState[button.order - 1] && !questionData.answered,

								chosenCorrect: typeof questionData.lastAnswer == 'object'
                ? questionData.lastAnswer[button.order-1] === true && questionData.answered === true && button.value === questionData.correctAnswer[button.order-1]
                : questionData.lastAnswer === button.value && questionData.answered === true && button.value === questionData.correctAnswer,

								chosenFalse: typeof questionData.lastAnswer == 'object'
                ? questionData.lastAnswer[button.order-1] === true && questionData.answered === true && button.value !== questionData.correctAnswer[button.order-1]
                : (questionData.lastAnswer === button.value) && questionData.answered === true && button.value !== questionData.correctAnswer && questionData.correctAnswer !== null,

								falseCorrect: typeof questionData.lastAnswer == 'object'
                ? !questionData.lastAnswer[button.order-1] && questionData.answered === true && button.value === questionData.correctAnswer[button.order-1]
                : questionData.lastAnswer !== button.value && questionData.answered === true && button.value === questionData.correctAnswer,

								noneCorrect: typeof questionData.lastAnswer == 'object'
                ? (questionData.lastAnswer[button.order-1] === button.value) && questionData.answered === true && questionData.correctAnswer[button.order-1] === undefined
                : (questionData.lastAnswer === button.value) && questionData.answered === true && questionData.correctAnswer === null,

								passive: resultState !== button.order && questionData.lastAnswer !== 'skip'}">

                <div class="left-box">
                  <span :class="['question_list_letter', 'answer-number-' + button.order]" v-html="button.letter"></span>
                </div>
                <p class="quiz_questions_list_text question_list_text" v-html="button.text"></p>
              </li>
            </ol>
            <!--            -->
          </transition>
          <div :class="[{'hidden' : questionData.answered === true}]" class="skip_container" v-if="questionData.multi">
            <p :class="{'submit-btn--active': this.multiResultState.includes(true)}" class="submit-text submit-btn" @click.prevent="answerQuestion('submit')">Submit</p>
          </div>

          <div :class="['skip_container', {'hidden' : questionData.answered === true}]">
            <p class="skip-text" @click.prevent="answerQuestion('skip')">Show the answer</p>
          </div>
        </div>

      </div>
    </div>
    <!-- removed quiz-lock according with feedback round -->
    <div
        class="quiz_lock_block"
        ref="quizLockBox"
        :class="[ 'quiz_lock_item--' + this.id ]"
        v-if="false"
    ></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

export default {
  name: 'Quiz',
  data() {
    return {
      scrollPos: null,
      resultState: 0,
      multiResultState: [],
      multiResponseObject: {},
      currentPatient: null,
      commitQuestion: {
        page: 0,
        question: 0,
        answer: '',
        percentage: 0,
        finalAnswer: false
      },
      content_scene: [],
      scrollOptions: {
        container: '',
        easing: 'ease-in',
        offset: 0,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
    };
  },
  props: {
    id: {
      type: Number
    },
    patientName: {
      type: String
    }
  },
  computed: {
    ...mapState(['routes', 'userAgent', 'quizData', 'currentPage', 'poll_info']),
    questionData() {
      return this.currentPatient = this.$store.state.quizData.patients[this.patientName].question[this.id];
    },
    isIE() {
      return this.userAgent.browser.name === 'ie';
    },
    returnStatQuizID() {
      if (this.id === 3 && this.patientName === 'susan') {
        return 3;
      } else if (this.patientName === 'joseph') {
        if (this.id === 1) {
          return 1
        } else if (this.id === 3) {
          return 3;
        } else return 4;
      } else if (this.patientName === 'gabrielle') {
        return 1;
      } else {
        return 1;
      }
    },
    isQuizWithStats() {
      // setted all pages and quiz-id's with stats
      return ((this.id === 3 && this.currentPage.isSusan) || ((this.id === 1 || this.id === 3 || this.id === 4) && this.currentPage.isJoseph) || (this.id === 1 && this.currentPage.isGabrielle));
    },
    lastButtonPercent() { // calculating last button percent to prevent bug with wrong amount of interest on quizzes
      if(this.isQuizWithStats) {
        let sum = 0;
        for (let buttonIndex in this.questionData.buttons) { // cycle with buttons
          if(buttonIndex < Object.keys(this.questionData.buttons).length - 1) { // if not last button
            // summ all buttons percent except the last one
            sum += Math.round((this.poll_info[this.patientName][this.returnStatQuizID][this.questionData.buttons[buttonIndex].letter] / this.poll_info[this.patientName][this.returnStatQuizID]['sum']) * 100);
          }
        }
        return 100 - sum;
      } else {
        return false;
      }
    }
  },
  methods: {
    updateScroll() {
      if (this.isIE) {
        this.scrollPos = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.getElementById('app') && document.getElementById('app').scrollTop || 0);
        window.scrollTo(0, this.scrollPos + 0.1);
      } else {
        return true;
      }
    },
    async answerQuestion(index, button) {
      if(this.questionData.answered === true) return true;

      if (this.questionData.answered !== true && index !== 'skip' && index !== 'submit') {
        this.resultState = index;
        this.multiResultState[index - 1] = !this.multiResultState[index - 1];

        if (this.multiResponseObject.hasOwnProperty(button.letter)) {
          delete this.multiResponseObject[button.letter];
        } else {
          this.multiResponseObject[button.letter] = 1;
        }

        this.commitQuestion = {
          page: this.patientName,
          question: this.id,
          answer: button.value,
          finalAnswer: true,
          multiple: this.questionData.multi ? this.multiResultState : false
        };

        this.$store.commit('UPDATE_ANSWER_STATE', this.commitQuestion);

        if (!this.$route.query.screentest) {
          let checkExist = setInterval(() => {
            if (document.querySelector(`.${this.$route.name.toString().toLowerCase()}_patient_section_${this.id + 1}`)) {
              // this.init_content_animation();
              clearInterval(checkExist);
              this.updateScroll();
            }
          }, 100);
        }

        if (!this.questionData.multi) {
          if (window.dataLayer) {
            window.dataLayer.push({
              'event': 'clinical-question',
              'patient': 'patient-' + this.$route.name.toLowerCase(),
              'question #': 'question-' + this.id,
              'question response': button.letter.toUpperCase()
            });
          }

          this.scrollToAnswer(this.id);
        }
      }

      if (index === 'skip' && this.questionData.answered !== true) {
        this.commitQuestion = {
          page: this.patientName,
          question: this.id,
          answer: 'skip',
          answerValues: this.multiResultState,
          multiple: this.questionData.multi ? this.multiResultState : false
        };
        this.$store.commit('UPDATE_ANSWER_STATE', this.commitQuestion);
        if (window.dataLayer) {
          window.dataLayer.push({
            'event': 'clinical-question',
            'patient': 'patient-' + this.$route.name.toLowerCase(),
            'question #': 'question-' + this.id,
            'question response': 'Skip'
          });
        }
        if (!this.$route.query.screentest) {
          let checkExist = setInterval(() => {
            if (document.querySelector(`.${this.$route.name.toString().toLowerCase()}_patient_section_${this.id + 1}`)) {
              this.init_content_animation();
              clearInterval(checkExist);
              this.updateScroll();
            }
          }, 100);
        }

        this.scrollToAnswer(this.id);
      }

      if (this.questionData.answered !== true && index === 'submit') {
        this.commitQuestion = { page: this.patientName, question: this.id, answer: 'submit', answerValues: this.multiResultState };
        this.$store.commit('UPDATE_ANSWER_STATE', this.commitQuestion);
        if (this.questionData.multi) {
          if (window.dataLayer) {
            window.dataLayer.push({
              'event': 'clinical-question',
              'patient': 'patient-' + this.$route.name.toLowerCase(),
              'question #': 'question-' + this.id,
              'question response': Object.keys(this.multiResponseObject)
            });
          }
        }
        this.updateScroll();

        this.scrollToAnswer(this.id);
      }

      if (this.questionData.answered === true && index !== 'skip' && ((this.id === 3 && this.currentPage.isSusan) || ((this.id === 1 || this.id === 3 || this.id === 4) && this.currentPage.isJoseph) || (this.id === 1 && this.currentPage.isGabrielle))) {
        await this.$store.dispatch('sendAnswer', {
          answers: this.multiResponseObject,
          patient: this.patientName,
          id: this.id
        });
      }
    },
    scrollToAnswer(index) {
      if (!this.$route.query.screentest) {
        setTimeout(() => {
          const windowHeight = window.innerHeight;
          const isiHeight = document.querySelector('.isi').offsetHeight;
          const elAnswer = document.querySelector(`#tip_${index}`);
          const answerHeight = elAnswer.offsetHeight;

          let scrollY = elAnswer.offsetTop - windowHeight + isiHeight + answerHeight;

          if(/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
            window.scrollTop = scrollY;
          } else {
            this.scrollOptions.offset = this.scrollOptions.offset - windowHeight + isiHeight + answerHeight
            this.$scrollTo(elAnswer, 500, this.scrollOptions);
            this.scrollOptions.offset = 0; // reset offset to initial value
          }
        }, 500);
      }
    },
    currentQuizNumber() {
      let data = {
        name: this.patientName,
        id: this.id
      };
      this.$store.commit('SET_QUIZ_PROGRESS', data);
      this.multiResultState.length = this.questionData.buttons.length;
    },
    init_content_animation(quiz) {
      if (!this.$store.state.controllerExist) {
        try {
          this.$scrollmagic.attachTo(document.querySelector('body'));
        }
        catch (e) {
          console.log('error!');
        }
        this.$store.commit('SET_SCROLL_CONTROLLER_STATE', true);
      }
      //
      let selectorConstruct = `.${this.$route.name.toString().toLowerCase()}_patient_section_${this.id + 1}`;
      if (quiz === 'first') {
        selectorConstruct = `.${this.$route.name.toString().toLowerCase()}_patient_section_${this.id}`;
      }
      //
      let common_section = document.querySelector(selectorConstruct);
      let common_block = common_section.querySelectorAll('.js-botTopFadeIn');
      if (common_block.length > 0) {
        common_block.forEach( (element,i) => {
          if (element.dataset['hasanim'] === '1') return true;
					element.dataset['hasanim'] = '1';
          let currentOffset = 0;
          var currentItem = element;
          var currentDuration = 0.4;
          var animDelay = 0;
          var tweenCurrentItem = new TimelineMax();
          tweenCurrentItem.fromTo(currentItem, currentDuration, { y: 40, opacity: 0, force3D:true }, { y: 0, opacity: 1, force3D:true }, '+=' + animDelay);
          tweenCurrentItem.call(() => {
            this.content_scene[i].destroy();
          });
          this.content_scene[i] = this.$scrollmagic.scene({ triggerHook: this.$route.query.screentest ? 1 : 0.7, triggerElement: currentItem, offset: currentOffset, reverse: false })
          // .addIndicators( {name: this.patientName + '-' + i} )
          .setTween(tweenCurrentItem);
          try {
            document.querySelector('body').$scrollmagic.addScene(this.content_scene[i]);
          }
          catch (e) {
            console.log('error!!');
          }
        });
      }
    },
  },
  mounted() {
    this.currentQuizNumber();
    // if (this.id === 1 && !this.$route.query.screentest) {
    //   let checkExist = setInterval(() => {
    //     if (document.querySelectorAll('.section_wrapper')[0].clientHeight > 0) {
    //       this.init_content_animation('first');
    //       clearInterval(checkExist);
    //     }
    //   }, 100);
    // }
  },
  destroyed() {
    document.querySelector('body').$scrollmagic.destroy();
    this.$store.commit('SET_SCROLL_CONTROLLER_STATE', false);
  }
};
</script>

<style lang="scss" src="./Quiz.scss"></style>
